// Third Party
import Image from 'next/image';

// UI
import noFees from '../../../public/assets/img/no-fees.png';
import professionalHosts from '../../../public/assets/img/professional-hosts.png';
import { Typography } from '@components/typography';

export const ValueSection: React.FC = () => {
  return (
    <div className="w-full h-full hidden sm:flex lg:space-y-0 space-x-4 lg:space-x-10 2xl:space-x-5 lg:flex-row justify-center items-start text-center mb-4">
      <div className="flex flex-col w-full h-full items-center">
        <Image
          src={noFees}
          className="block items-center py-4"
          alt="logo"
          height={50}
        />
        <Typography
          component="h4"
          className="font-medium pb-1.5 text-xl -mt-0.5 whitespace-nowrap"
        >
          No Service Fees
        </Typography>
        <div className="text-sm mx-2 max-w-lg">
          Save money by booking directly with your host without any Savvy
          service fees added to your stay.
        </div>
      </div>
      <div className="flex flex-col w-full h-full items-center">
        <Image
          src={professionalHosts}
          className="block items-center py-4"
          alt="logo"
          height={51}
        />
        <Typography
          component="h4"
          className="font-medium pb-1.5 text-xl -mt-1 whitespace-nowrap"
        >
          Professional Hosts
        </Typography>
        <div className="text-sm mx-2 max-w-lg">
          Enjoy peace of mind knowing your host is a professional property
          manager that will ensure a consistent and reliable stay.
        </div>
      </div>
    </div>
  );
};
